import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { BRAND, IMAGES } from "@/data/content";

export const CtaBanner = () => (
  <section className="py-20 lg:py-24 bg-white" data-testid="cta-banner">
    <div className="container-x">
      <div className="relative overflow-hidden rounded-[2.5rem] bg-brand-navy">
        <div className="absolute inset-0 bg-dotgrid opacity-50" />
        <img
          src={IMAGES.caregiver}
          alt=""
          aria-hidden="true"
          className="absolute right-0 top-0 h-full w-1/2 object-cover opacity-30 hidden md:block"
        />
        <div className="absolute right-0 top-0 h-full w-1/2 bg-gradient-to-l from-transparent to-brand-navy hidden md:block" />

        <div className="relative p-8 sm:p-14 lg:p-16 max-w-2xl">
          <span className="eyebrow text-brand-red">
            <span className="relative flex h-2.5 w-2.5">
              <span className="absolute inline-flex h-full w-full rounded-full bg-brand-red animate-pulseRing" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-brand-red" />
            </span>
            An operator is on duty right now
          </span>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="mt-5 font-display font-black text-4xl sm:text-5xl text-white leading-[1.02]"
          >
            Stop worrying.
            <br />
            <span className="text-brand-red">Start protecting.</span>
          </motion.h2>
          <p className="mt-5 text-lg text-white/75 leading-relaxed">
            Get a free 60-second quote or talk to a specialist today. No pressure, no long-term
            contract, and free US shipping on every device.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-3.5">
            <a
              href={BRAND.phoneHref}
              data-testid="cta-call-button"
              className="btn-focus inline-flex items-center justify-center gap-2.5 h-15 min-h-[60px] px-8 rounded-full bg-brand-red text-white font-bold text-lg hover:bg-brand-red-600 transition-colors shadow-red"
            >
              <Phone className="w-5 h-5" strokeWidth={2.6} />
              {BRAND.phone}
            </a>
            <Link
              to="/contact"
              data-testid="cta-quote-button"
              className="btn-focus group inline-flex items-center justify-center gap-2 h-15 min-h-[60px] px-8 rounded-full bg-white text-brand-navy font-bold text-lg hover:bg-white/90 transition-colors"
            >
              Get my free quote
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" strokeWidth={2.6} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  </section>
);
